// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2cXCZ","footer":"ModalError_footer__2XpeT"};